module.exports = __webpack_public_path__ + "img/TheEducationLeaders.6c882525.jpg";